import { render, staticRenderFns } from "./repayment-info.vue?vue&type=template&id=21400a12&scoped=true&"
import script from "./repayment-info.vue?vue&type=script&lang=js&"
export * from "./repayment-info.vue?vue&type=script&lang=js&"
import style0 from "./repayment-info.vue?vue&type=style&index=0&id=21400a12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21400a12",
  null
  
)

export default component.exports